import axiosLibrary from 'axios'
import updateHeaderInterceptor from './updateHeader'

const axios = axiosLibrary.create({
  baseURL: process.env.REACT_APP_IP_SERVER,
})

updateHeaderInterceptor(axios)

export default axios
